/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';
import { FaInstagram, FaLinkedin, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

import BrandIcon from './BrandIcon';
import Button from '../elements/Button';

export default function Footer() {
  return (
    <div className="bg-dark-theme-purple border-t border-gray-700 pb-6">
      <div className="container flex-col mx-auto ">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-8 justify-items-start px-6 lg:px-0">
          <div className="flex-col">
            <BrandIcon variant="light" />
              <p className="w-full text-lg text-gray-400 font-light ml-4">
              Comprehensive ERP Solutions  Stone Crusher Management  Digital Marketing
              {' '}
              <br />
              Cutting-Edge Website Design  24/7 Support & Services
            </p>
          </div>
          
          {/* <div className="mt-0">
            <h1 className="text-lg text-theme-blue pt-4 pb-2">
              Social
            </h1>
            <Button href="https://www.instagram.com/zerlak_technology/" type="link" target="_blank" className="flex text-lg text-gray-400 font-light hover:underline" isExternal>
              Instagram
            </Button>
            <Button href="https://www.linkedin.com/company/zerlak-technology-pvt-ltd/posts/?feedView=all" type="link" target="_blank" className="flex text-lg text-gray-400 font-light hover:underline" isExternal>
              LinkedIn
            </Button>
          </div> */}
          <div className="mt-0">
            <h1 className="text-lg text-white pt-4 pb-2">Services</h1>
            <ul className="space-y-1">
              <li>
                <Button type="link" href="/project" className="text-lg text-gray-400 font-light hover:underline">ERP Solutions</Button>
              </li>
              <li>
                <Button type="link" href="/project" className="text-lg text-gray-400 font-light hover:underline">Stone Crusher Management</Button>
              </li>
              <li>
                <Button type="link" href="/project" className="text-lg text-gray-400 font-light hover:underline">Digital Marketing</Button>
              </li>
              <li>
                <Button type="link" href="/project" className="text-lg text-gray-400 font-light hover:underline">Web Development</Button>
              </li>
              <li>
                <Button type="link" href="/project" className="text-lg text-gray-400 font-light hover:underline">Mobile Development</Button>
              </li>
              <li>
                <Button type="link" href="/project" className="text-lg text-gray-400 font-light hover:underline">UI/UX Design</Button>
              </li>
            </ul>
          </div>

          
          <div className="mt-0">
            <h1 className="text-lg text-white pt-4 pb-2">Social</h1>
            <ul className="space-y-1">
              <li>
                <Button
                  href="https://www.instagram.com/zerlak_technology/"
                  type="link"
                  target="_blank"
                  className="flex items-center gap-2 text-lg text-gray-400 font-light hover:underline"
                  isExternal
                >
                  <FaInstagram aria-hidden="true" />
                  <span>Instagram</span>
                </Button>
              </li>
              <li>
                <Button
                  href="https://www.linkedin.com/company/zerlak-technology-pvt-ltd/posts/?feedView=all"
                  type="link"
                  target="_blank"
                  className="flex items-center gap-2 text-lg text-gray-400 font-light hover:underline"
                  isExternal
                >
                  <FaLinkedin aria-hidden="true" />
                  <span>LinkedIn</span>
                </Button>
              </li>
            </ul>
          </div>
          <div className="mt-0">
            <h1 className="text-lg text-white pt-4 pb-2">Office</h1>
            <ul className="space-y-1">
              <li className="flex items-start gap-2 text-lg text-gray-400 font-light">
                <FaEnvelope className="mt-1" aria-hidden="true" />
                <a href="mailto:business@zerlak.com" className="hover:underline">business@zerlak.com</a>
              </li>
              <li className="flex items-start gap-2 text-lg text-gray-400 font-light">
                <FaMapMarkerAlt className="mt-1" aria-hidden="true" />
                <address className="not-italic">
                  Office No B-18, Third Floor, Shivam Complex,<br />
                  Near Shankar Math, Hadapsar, Pune 411028
                </address>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex-col text-center mt-7">
          <p className="text-lg text-gray-400 font-light">© 2025 Zerlak. All Rights Reserved.</p>
          
        </div>
      </div>
    </div>
  );
}
